import Footer from "../components/Footer";
import MarketingNav from "../components/layout/MarketingNav";
import {
  AboutDifferent,
  AboutFinalCTA,
  AboutHero,
  AboutHowItWorks,
  AboutImpact,
  AboutJourney,
  AboutProblem,
  AboutRoadmap,
  AboutValues,
  AboutWhy,
} from "../components/about/AboutSections";

const About = () => (
  <div className="min-h-screen bg-white flex flex-col overflow-visible">
    <MarketingNav />
    <main className="overflow-visible">
      <AboutHero />
      <AboutProblem />
      <AboutWhy />
      <AboutHowItWorks />
      <AboutJourney />
      <AboutDifferent />
      <AboutValues />
      <AboutRoadmap />
      <AboutImpact />
      <AboutFinalCTA />
    </main>
    <Footer />
  </div>
);

export default About;
